import {Component, OnInit} from '@angular/core';
import {Spedizione} from '../../../_models/Spedizione';
import {SpedizioniService} from '../../../_services/spedizioni.service';
import {OrganizzazioniService} from '../../../_services/organizzazioni.service';
import {ModalController} from '@ionic/angular';
import {SaveMessage} from '../../../_helpers/save-message';
import {AnagraficaBase} from '../../../_models/AnagraficaBase';
import {AuthenticationService} from '../../../_services/authentication.service';
import {StatoEnum} from '../../../_models/generated/stato-enum'
import {TipoRisorsa} from '../../../_models/generated/tipo-risorsa'

const emptySpedizione: Spedizione = {
  organizzazioneId: 0,
  idSpedizione: 0,
  idAnagrafica: 0,
  ragSocAnagrafica: '',
  idIndrizzoSped: 0,
  palletCount: 0,
  dataUnixRegistrazione: 0,
  executedBy: '',
  stato: StatoEnum.DA_PIANIFICARE,
  contesto: 4
};

@Component({
  selector: 'app-documento-magazzino-create',
  templateUrl: './documento-magazzino-create.component.html',
  styleUrls: ['./documento-magazzino-create.component.scss'],
  standalone: false
})
export class DocumentoMagazzinoCreateComponent implements OnInit {
  spedizione: Spedizione;
  rifEsterno = '';
  contesto = 4;
  idDocumento: number;
  idRiga: number;
  idRigaLavorazione: number;
  dataDocOriginale = new Date();
  idAnagrafica = 0;
  ragSocAnagrafica = '';
  tipoAnagr = 2;
  loading = false;

  constructor(
    private authService: AuthenticationService,
    private organizzazioniService: OrganizzazioniService,
    private spedizioniService: SpedizioniService,
    private modalCtrl: ModalController,
    private saveMessage: SaveMessage) { }

  ngOnInit() {
    this.spedizione = emptySpedizione;
    this.spedizione.executedBy = this.authService.currentUserValue.userName;
    this.spedizione.rifDocEsterno = this.rifEsterno;
    this.spedizione.contesto = this.contesto;
    this.spedizione.dataDocumento = this.dataDocOriginale ?? new Date();
    this.spedizione.idAnagrafica = this.idAnagrafica;
    this.spedizione.ragSocAnagrafica = this.ragSocAnagrafica;
    this.spedizione.organizzazioneId = this.organizzazioniService.organizzazioneId;
    this.spedizione.idDocumento = this.idDocumento;
    this.spedizione.idRiga = this.idRiga;
    this.spedizione.idRigaLavorazione = this.idRigaLavorazione;
  }

  selectAnagrafica = (anagrafica: AnagraficaBase) => {
    this.spedizione.idAnagrafica = anagrafica.id;
    this.spedizione.ragSocAnagrafica = anagrafica.ragSociale;
  };

  confirm() {
    this.loading = true;
    this.spedizioniService.createSpedizione(this.spedizione)
      .then(this.succesSave)
      .catch(this.errorSave)
      .finally(() => this.loading = false);
  }

  succesSave = (_spedizione: Spedizione) => {
    this.saveMessage.messageInfo('Operazione eseguita con successo.');
    this.modalCtrl.dismiss(this.spedizione, 'confirm');
  };

  errorSave = () => this.saveMessage.messageError("Ci sono problemi con il salvataggio.");

  cancel = () => this.modalCtrl.dismiss(false, 'cancel');
  protected readonly TipoRisorsa = TipoRisorsa
}
